/**
 * 预处理内容：占位符替换 + 引号规范化
 * 可独立使用，不依赖 React
 */
export function preprocessContent(
  content: string,
  characterName?: string,
  userName?: string
): string {
  if (!content) return ''

  let result = content

  // 1. 替换角色/用户占位符
  if (characterName) {
    result = result.replace(/{{char}}/g, characterName)
  }
  if (userName) {
    result = result.replace(/{{user}}/g, userName)
  }

  // 2. 引号规范化（与原生一致）
  // result = result
  //   .replaceAll('"', '"')
  //   .replaceAll('"', '"')
  //   .replaceAll('«', '"')
  //   .replaceAll('»', '"')

  return result
}
